import { render } from "./SlideoutPanel.vue?vue&type=template&id=d82963e2&scoped=true"
import script from "./SlideoutPanel.vue?vue&type=script&lang=js"
export * from "./SlideoutPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d82963e2"]])

export default __exports__